import React from 'react';

import ShutdownAlertIcon from '@/comp/common/icons/ShutdownAlertIcon';
import WarningAlertIcon from '@/comp/common/icons/WarningAlertIcon';
import ServiceAlertIcon from '@/comp/common/icons/ServiceAlertIcon';
import { AlertLevels } from '@/constants/enums';

interface SeverityIconProps {
  severity: AlertLevels;
  width?: number;
  height?: number;
}

const SeverityIcon = ({ severity, ...props }: SeverityIconProps) => {
  switch (severity) {
    case AlertLevels.Shutdown:
      return <ShutdownAlertIcon {...props} />;

    case AlertLevels.Warning:
      return <WarningAlertIcon {...props} />;

    case AlertLevels.Service:
      return <ServiceAlertIcon {...props} />;

    default:
      return null;
  }
};

export default SeverityIcon;
